import {
  AUTH_ENABLE_GOOGLE_SOCIAL_SIGN_IN,
  AUTH_ENABLE_MICROSOFT_SOCIAL_SIGN_IN,
  AUTH_SOCIAL_DIVIDER_LABEL,
  AUTH_SOCIAL_GOOGLE_LABEL,
  AUTH_SOCIAL_MICROSOFT_LABEL,
  GOOGLE,
  MICROSOFT,
} from 'common/constants/auth';
import { Button, Stack } from 'components/ui';
import { Google as GoogleIcon, Microsoft as MicrosoftIcon } from 'icons';
import AuthDivider from 'pages/Auth/components/AuthDivider';
import { AuthSocialButtonsProps } from './AuthSocialButtons.props';

const AuthSocialButtons = ({
  disabled = false,
  onGoogleLogin,
  onMicrosoftLogin,
  socialProviderPending,
}: AuthSocialButtonsProps) => {
  const showAnySocialSignIn = AUTH_ENABLE_GOOGLE_SOCIAL_SIGN_IN || AUTH_ENABLE_MICROSOFT_SOCIAL_SIGN_IN;

  if (!showAnySocialSignIn) {
    return null;
  }

  return (
    <>
      <AuthDivider label={AUTH_SOCIAL_DIVIDER_LABEL} />
      <Stack direction={{ sm: 'row', xs: 'column' }} spacing={2} width="100%">
        {AUTH_ENABLE_GOOGLE_SOCIAL_SIGN_IN ? (
          <Button
            disabled={disabled}
            fullWidth
            loading={socialProviderPending === GOOGLE}
            onClick={onGoogleLogin}
            startIcon={<GoogleIcon />}
            sx={{
              '& .MuiButton-startIcon': {
                marginRight: '12px',
              },
              flex: { sm: 1 },
              whiteSpace: 'nowrap',
            }}
            type="button"
            variant="outlined"
            visualVariant="neutralOutline"
          >
            {AUTH_SOCIAL_GOOGLE_LABEL}
          </Button>
        ) : null}
        {AUTH_ENABLE_MICROSOFT_SOCIAL_SIGN_IN ? (
          <Button
            disabled={disabled}
            fullWidth
            loading={socialProviderPending === MICROSOFT}
            onClick={onMicrosoftLogin}
            startIcon={<MicrosoftIcon />}
            sx={{
              '& .MuiButton-startIcon': {
                marginRight: '12px',
              },
              flex: { sm: 1 },
              whiteSpace: 'nowrap',
            }}
            type="button"
            variant="outlined"
            visualVariant="neutralOutline"
          >
            {AUTH_SOCIAL_MICROSOFT_LABEL}
          </Button>
        ) : null}
      </Stack>
    </>
  );
};

export default AuthSocialButtons;
